import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { onKeyPressNumbers } from '../../services/Utils'
import { Link } from 'react-router-dom'


const INIT = {
    name: '',
    description: '',
    subsidiary_id: '',
    code: '',
    installed_date: '',
    installed_version: '',
    active: true,
}

const CheckoutsEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [currentSubsidiary, setCurrentSubsidiary] = React.useState(false)
    const disabled = !data.name || !data.description || !data.code || !data.subsidiary_id


    const getData = () => {
        setloading(true)
        API.get(`/api/checkouts/${match.params.id}`)
            .then(response => {
                setData(response.data)
                setloading(false)
                if (response.data.subsidiary_id) {
                    setCurrentSubsidiary(response.data.subsidiary.name)
                }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.patch(`/api/checkouts/${match.params.id}`, data)
            .then(() => {
                setloading(false)
                notification.success({
                    message: 'La caja se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    const handleClear = e => {
        setloading(true)
        e.preventDefault()
        API.post(`/api/checkouts/${match.params.id}/uninstall`)
            .then((response) => {
                setloading(false)
                notification.success({
                    message: response.data.message,
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Editar la caja</Divider>

            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>

                <Button onClick={handleClear}>
                    Limpiar caja
                </Button>

                <Form.Item label="Código" className="required" hasFeedback>
                    <Input
                        placeholder="Código"
                        value={data.code}
                        onKeyPress={onKeyPressNumbers}
                        onChange={e => {
                            handleChange('code', e.target.value)
                        }}
                    />
                </Form.Item>
                <Form.Item label="Nombre" className="required" hasFeedback>
                    <Input
                        placeholder="Nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripición" className="required" hasFeedback>
                    <Input
                        placeholder="Descripición"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Sucursal" className="required">
                    <Search
                        value={currentSubsidiary}
                        placeholder="Busca una sucursal"
                        onSearch={value => `/api/subsidiaries?filter[name]=${value}&filter[active]=1`}
                        onChange={(key, value) => {
                            handleChange('subsidiary_id', key)
                            setCurrentSubsidiary(value.name)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/checkouts">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default CheckoutsEditContainer
